if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      if(this.querySelector('form')){
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }else {
        this.querySelector('[name=id]').disabled = false
         this.querySelector('button[type=submit]').addEventListener(
						'click',
						this.onSubmitHandler.bind(this)
					)
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
				formData.append('id', this.querySelector('[name=id]').value)
			}

      // Collect selected addon (complementary) products
      const addonSelects = document.querySelectorAll('.associated-products select[data-addon-variant]');
      const addonItems = [];
      addonSelects.forEach((select) => {
        if (select.value) {
          addonItems.push({ id: parseInt(select.value), quantity: 1 });
        }
      });

      if (addonItems.length > 0) {
        // Bundle main product + addon products using items format
        const items = [
          { id: parseInt(formData.get('id')), quantity: parseInt(formData.get('quantity')) || 1 },
          ...addonItems
        ];
        const body = { items: items };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(body);
      } else {
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          // CART ERROR EVENT
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message
                }
              })
            );
            // -------------------------------------------
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // VARIANT ADDED EVENT
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.section
              }
            })
          );
          // -------------------------------------------

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });

            // CART CHANGE EVENT
            document.dispatchEvent(
              new CustomEvent("cart:change", {
                detail: response,
                bubbles: true
              })
            );
          }
          this.error = false;
          // Reset addon selects after successful add
          addonSelects.forEach((select) => { select.value = ''; });
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// Complementary product variant price update
(function() {
  function formatMoney(cents) {
    if (cents == null || cents === '') return '';
    var format = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.floor(cents / 100);
    var amountWithComma = amount.replace('.', ',');
    var amountNoDecimalsWithComma = amountNoDecimals.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountWithPeriodAndComma = amount.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');

    return format
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithComma)
      .replace('{{amount_with_apostrophe_separator}}', amount.replace(/(\d)(?=(\d{3})+\.)/g, "$1'"))
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amountWithPeriodAndComma);
  }

  document.addEventListener('change', function(e) {
    var select = e.target;
    if (!select.matches || !select.matches('select[data-addon-variant]')) return;

    var card = select.closest('.horizontal-product');
    if (!card) return;

    var priceContainer = card.querySelector('.horizontal-product__price .price');
    if (!priceContainer) return;

    var selectedOption = select.options[select.selectedIndex];
    var price = selectedOption.getAttribute('data-price');
    var compareAtPrice = selectedOption.getAttribute('data-compare-at-price');

    // "None selected" — restore first variant price from first real option
    if (!price) {
      var firstOption = select.querySelector('option[data-price]');
      if (!firstOption) return;
      price = firstOption.getAttribute('data-price');
      compareAtPrice = firstOption.getAttribute('data-compare-at-price');
    }

    var priceNum = parseInt(price, 10);
    var compareNum = compareAtPrice ? parseInt(compareAtPrice, 10) : 0;
    var isOnSale = compareNum > priceNum;

    // Update regular price display
    var regularPriceEl = priceContainer.querySelector('.price__regular .price-item--regular');
    if (regularPriceEl) {
      regularPriceEl.innerHTML = formatMoney(priceNum);
    }

    // Update sale price display
    var salePriceEl = priceContainer.querySelector('.price__sale .price-item--sale');
    if (salePriceEl) {
      salePriceEl.innerHTML = formatMoney(priceNum);
    }

    var compareEl = priceContainer.querySelector('.price__sale .price-item--regular');
    if (compareEl) {
      compareEl.innerHTML = isOnSale ? formatMoney(compareNum) : '';
    }

    // Toggle sale class
    priceContainer.classList.toggle('price--on-sale', isOnSale);
  });
})();
